import { cn } from "@roman/shared/utils";
import { LiveBadge } from "../myEntry/LiveBadge";

type MyContestBadgeProps = {
  className?: string;
  subClassName?: string;
  iconClassName?: string;
  textClassName?: string;
};
export const MyContestBadge = ({ className, subClassName, iconClassName, textClassName }: MyContestBadgeProps) => {
  return (
    <div className={cn("absolute -top-[14px] left-1/2 transform -translate-x-[50%] h-[14px]", className)}>
      <LiveBadge
        className=""
        subClassName={cn("bg-primary space-x-1", subClassName)}
        iconClassName={iconClassName}
        textClassName={cn("text-white font-semibold text-[10px] leading-[10px]", textClassName)}
        text="LIVE"
        isInMenu={true}
      />
    </div>
  );
};
